import { Component, OnInit } from '@angular/core';
import { ModulesLandingControllerComponent } from '../modules-landing-controller/modules-landing-controller.component';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrl: './landing-page.component.scss'
})
export class LandingPageComponent extends ModulesLandingControllerComponent implements OnInit {
  pageTitle: string = ''
  landingModuleName: string = ''

  ngOnInit(): void {
    const routeUrl = this.route.url;
    if (routeUrl.includes('/fixed-assets/landing')) {
      this.pageTitle = 'sideNav.fixedAssets'
      this.landingModuleName = this.landingModulesNames.fixedAssets
    } else if (routeUrl.includes('/purchasing/landing')) {
      this.pageTitle = 'sideNav.purchasing'
      this.landingModuleName = this.landingModulesNames.purchasing
    } else if (routeUrl.includes('/pos/landing')) {
      this.pageTitle = 'sideNav.pos'
      this.landingModuleName = this.landingModulesNames.pos
    } else if (routeUrl.includes('/manufacturing/landing')) {
      this.pageTitle = 'sideNav.manufacturing'
      this.landingModuleName = this.landingModulesNames.manufacturing
    } else if (routeUrl.includes('/invoicing/landing')) {
      this.pageTitle = 'sideNav.invoicing'
      this.landingModuleName = this.landingModulesNames.invoicing
    } else if (routeUrl.includes('/data/landing')) {
      this.pageTitle = 'sideNav.data'
      this.landingModuleName = this.landingModulesNames.dataModule
    } else if (routeUrl.includes('/system/landing')) {
      this.pageTitle = 'sideNav.system'
      this.landingModuleName = this.landingModulesNames.systemModule
    } else if (routeUrl.includes('/subscriptions/landing')) {
      this.pageTitle = 'sideNav.subscriptions'
      this.landingModuleName = this.landingModulesNames.subscriptions
    }
  }
}
